import { render, staticRenderFns } from "./MakeSuggestion.vue?vue&type=template&id=3bae27f6&"
import script from "./MakeSuggestion.vue?vue&type=script&lang=js&"
export * from "./MakeSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports